var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,27.22c-14.54,0-26.97,9.08-31.9,21.89-.22.57-.22,1.2,0,1.77,4.93,12.81,17.36,21.89,31.9,21.89s26.97-9.08,31.9-21.89c.22-.57.22-1.2,0-1.77-4.93-12.81-17.36-21.89-31.9-21.89ZM11.01,46.38c6.03-15.65,21.2-26.76,38.99-26.76s32.96,11.11,38.99,26.76c.9,2.33.9,4.9,0,7.23-6.03,15.65-21.2,26.76-38.99,26.76s-32.96-11.11-38.99-26.76c-.9-2.33-.9-4.9,0-7.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,42.41c-4.19,0-7.59,3.4-7.59,7.59s3.4,7.59,7.59,7.59,7.59-3.4,7.59-7.59-3.4-7.59-7.59-7.59ZM34.81,50c0-8.39,6.8-15.19,15.19-15.19s15.19,6.8,15.19,15.19-6.8,15.19-15.19,15.19-15.19-6.8-15.19-15.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeView);
export default __webpack_public_path__ + "static/media/acae_view.eed8adb9.svg";
export { ForwardRef as ReactComponent };